// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: #11172E !important;
}
.fill-yellow-hover {

    fill: #f24e4e;

}
.fill-gray {
    fill: #1b6af6;

}
.fill-red {
    fill: #fdc340;
}
.fill-green {
    fill: #0eec07;
}
.select-color__colors {
    display: flex;
    gap: .4rem;
    margin-top: 1rem;
    height: 4.6rem;
}
.select-color__color[_ngcontent-ng-c3991595663] .icon[_ngcontent-ng-c3991595663] {
    font-size: 1.6rem;
    opacity: 0;
    transition: opacity .2s ease-out 0s;
    display: none;
}
.icon {
    position: relative;
    color: inherit;
    font-family: icomoon !important;
    font-style: normal;
    font-weight: 400;
    font-feature-settings: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
canvas{
    animation: AppearCanvas 1s ease-in-out;
}
.count_players{
    position: absolute;
    right: 10px;
    top:10px;
    background-color: rgba(17,23,32,.75);
    padding: 10px;
    border-radius: 10px;
    z-index: 3;
}
.canvas{
    transition: width 2s;

}
.gameCont{
    transition: opacity 1s;
}
.btnBet {
    --bgc: transparent;
    --border-color: transparent;
    --icon-size: 2.2rem;
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
    gap: .6rem;
    /*width: auto;*/
    min-width: auto;
    height: 3rem;
    background-color: var(--bgc);
    padding-inline: 1rem;
    border-width: 0;
    border-style: solid;
    border-color: var(--border-color);
    border-radius: 1rem;
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 1;
    opacity: 1;
    text-transform: none;
    white-space: nowrap;
    overflow: hidden;
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
    transition: --main-btn-gradient-start .2s ease-out 0s, --main-btn-gradient-end .2s ease-out 0s, background-color .2s ease-out 0s, border-color .2s ease-out 0s, color .2s ease-out 0s, filter .2s ease-out 0s, opacity .2s ease-out 0s, visibility .2s ease-out 0s;
}

/*body>canvas { width:100%!important; height:100%!important;*/
/*    position:fixed; top:0; left:60px }*/
.canvas {
    position: relative;
}

.bet-form {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 330px;
}

.bet-form__label {
    color: whitesmoke;
    font-family: "Gilroy", sans-serif;
    font-weight: 500;
    font-size: 1.2rem;
    line-height: 1.6rem;
    text-align: center;
    letter-spacing: 1px;
}

.bet-form__wrapper {
    position: relative;
    display: flex;
    align-items: center;
    gap: .4rem;
    width: 100%;
    height: 3.5rem;
    margin-top: 1rem;
    border: 1px solid transparent;
    border-color: #3b477a;
    border-radius: .8rem;
}

.manual-bet__actions {
    display: flex;
    gap: .4rem;
    height: 2.8rem;
    margin-top: .5rem;
    
}

.manual-bet__action.is-active {
    background-color: #6288d4;
    color: #f4f7ff;
}


.manual-bet__action {
    background-color: #333f70;
    color: #a5b6e0;
    flex: 1 1 100%;
    height: 100%;
    padding: 7px;
    border: none;
    border-radius: .8rem;
    font-size: 0.9rem;
    font-weight: 700;
    line-height: 1.5rem;
}

.currency_CSF, .currency_USD {
    display: inline-flex;
    align-items: center;
    gap: .2rem;
    font-feature-settings: "tnum";
    font-variant: tabular-nums;
    letter-spacing: 1px;
}

.bet-form__wrapper .bet-form__currency {
    display: block;
    margin-left: 1.4rem;
    font-weight: 500;
    font-size: 1.5rem;
    color: #b3c3ec;
}

.bet-form__input, .bet-form__input::placeholder {
    color: #e0e6ff;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.8rem;
}

.bet-form__input {
    width: 100%;
    height: 100%;
    padding: 0;
    background-color: transparent;
    border: none;
    border-radius: inherit;
    transition: filter .2s ease-out 0s;
}
.manual-bet__form .fa-trash{
    font-size: 1.5rem;
    margin-right: 10px;
    color: #58638980;
    cursor: pointer;
}



/*.btn{*/
/*    --bgc: transparent;*/
/*    --border-color: transparent;*/
/*    --icon-size: 2.2rem;*/
/*    position: relative;*/
/*    display: inline-flex;*/
/*    justify-content: center;*/
/*    align-items: center;*/
/*    flex: 0 0 auto;*/
/*    gap: .6rem;*/
/*    width: auto;*/
/*    min-width: auto;*/
/*    height: 6.4rem;*/
/*    background-color: var(--bgc);*/
/*    padding-inline: 1rem;*/
/*    border-width: 0;*/
/*    border-style: solid;*/
/*    border-color: var(--border-color);*/
/*    border-radius: 1rem;*/
/*    font-weight: 700;*/
/*    font-size: 1.6rem;*/
/*    line-height: 1;*/
/*    color: var(--color, #fff);*/
/*    opacity: 1;*/
/*    text-transform: none;*/
/*    white-space: nowrap;*/
/*    overflow: hidden;*/
/*    -webkit-user-select: none;*/
/*    user-select: none;*/
/*    cursor: pointer;*/
/*    -webkit-transition: --main-btn-gradient-start .2s ease-out 0s,--main-btn-gradient-end .2s ease-out 0s,background-color .2s ease-out 0s,border-color .2s ease-out 0s,color .2s ease-out 0s,filter .2s ease-out 0s,opacity .2s ease-out 0s,visibility .2s ease-out 0s;*/
/*    -moz-transition: --main-btn-gradient-start .2s ease-out 0s,--main-btn-gradient-end .2s ease-out 0s,background-color .2s ease-out 0s,border-color .2s ease-out 0s,color .2s ease-out 0s,filter .2s ease-out 0s,opacity .2s ease-out 0s,visibility .2s ease-out 0s;*/
/*    transition: --main-btn-gradient-start .2s ease-out 0s,--main-btn-gradient-end .2s ease-out 0s,background-color .2s ease-out 0s,border-color .2s ease-out 0s,color .2s ease-out 0s,filter .2s ease-out 0s,opacity .2s ease-out 0s,visibility .2s ease-out 0s;*/

/*}*/

.bet-creator__action {
    margin-top: 1rem;
    width: 100%;
    border-radius: .8rem;
}

.btn_blue {
    background-color: #5d7ef2;
    color: #fff;

}

.select-color__color {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .4rem;
    /*height: 100%;*/
    border-radius: 1rem;
    padding: 1rem 0;
    flex: 1 1;

    /*font-size: 1.5rem;*/
    line-height: 1.8rem;
    text-transform: uppercase;
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
    border: 1px solid transparent;
    opacity: .5;
    background: linear-gradient(180deg, rgba(90, 96, 228, .224) 0%, rgba(88, 103, 236, .64) 100%);
    border-color: var(--border-color);
    transition: opacity .2s ease-out 0s, --bg-color-start .2s ease-out 0s, --bg-color-end .2s ease-out 0s, --border-color .2s ease-out 0s;
}
.select-color__color.small{

}

.selected {
    opacity: 1;
}

@media (max-width: 1000px) {
    
    .btn_blue {
        height: 4rem;


    }

    .btnBet {
        height: 3rem;
    }

    .bet-creator__action {
        margin-top: 0;
    }

    .bet-form__wrapper {
        margin-top: 10px;
        height: 3.5rem;
    }

    


}
@keyframes AppearCanvas {
    0%{
        opacity: 0.1;
    }
    100%{
        opacity: 1;
    }
}
@keyframes Appear {
    0% {

        opacity: 0.1;


    }
    100% {

        opacity: 1;

    }
}

.gameCont {
   
    animation-name: Appear; /* Указываем имя вашей анимации */
    animation-duration: 2s; /* Устанавливаем продолжительность анимации */
    animation-timing-function: ease; /* Устанавливаем функцию времени (timing function) */
    animation-iteration-count: 1; /* Устанавливаем количество повторений анимации */
    transition: width 2s, height 4s,opacity 1s;
    width: 100%;
    cursor: default!important;

    display: flex;
    order: 2;

}



@keyframes side_center_gameCont {
    0% {

        max-width: 800px;
        margin: 0 0;


    }

    100% {
        max-width: 1200px;
        margin: 0 auto;

    }
}

@keyframes side_left_gameCont {
    0% {
        max-width: 1200px;
        transform: translateX(0); /* Начальное положение блока */


    }

    100% {
        max-width: 800px;
        margin: 0 0;

    }

}

.gameCont.close {
    
    


    opacity: 1 !important;


}

.select-color__color.is-active.select-color__color_x2 {
    --font-color: #94B2FF;
    --bg-color-start: rgba(90, 96, 228, .224);
    --bg-color-end: rgba(88, 103, 236, .64);
    --border-color: rgba(139, 157, 254, .18);
}




.select-color__color_x2 {
    --font-color: #94B2FF;
    --bg-color-start: rgba(90, 96, 228, .224);
    --bg-color-end: rgba(88, 103, 236, .64);
    --border-color: rgba(139, 157, 254, .18);

}
.select-color__color_x50 {
    --font-color: #A4FDC7;
    --bg-color-start: rgba(43, 172, 71, .224);
    --bg-color-end: rgba(74, 202, 110, .64);
    --border-color: rgba(139, 254, 185, .18);

}
.select-color__color_x3 {
    --font-color: #ef294e;
    --bg-color-start: rgb(208 74 74 / 12%);
    --bg-color-end: rgb(255 11 11 / 34%);
    --border-color: rgba(184, 151, 255, .18);
}
.select-color__color_x5 {
    --font-color: #FFEDC8;
    --bg-color-start: rgba(216, 164, 87, .224);
    --bg-color-end: rgba(218, 197, 87, .64);
    --border-color: rgba(254, 208, 139, .18);
}
.select-color__color_x2_block {
    --font-color: #94B2FF;
    --bg-color-start: rgb(90, 96, 228);
    --bg-color-end: rgb(88, 103, 236);
    --border-color: rgb(139, 157, 254);

}
.select-color__color_x50_block {
    --font-color: #A4FDC7;
    --bg-color-start: rgb(43, 172, 71);
    --bg-color-end: rgb(74, 202, 110);
    --border-color: rgb(139, 254, 185);

}
.select-color__color_x3_block {
    --font-color: #ef294e;
    --bg-color-start: rgb(208 74 74);
    --bg-color-end: rgb(255 11 11);
    --border-color: rgb(184, 151, 255);
}

.select-color__color_x5_block {
    --font-color: #FFEDC8;
    --bg-color-start: rgba(216, 164, 87);
    --bg-color-end: rgba(218, 197, 87);
    --border-color: rgba(254, 208, 139);
}

.select-color__color {
    display: flex;
    align-items: center;
    letter-spacing: 1px;
    justify-content: center;
    gap: .4rem;
    height: 2rem;
    width: 5.3rem;
    border-radius: 0.7rem;
    padding: 1.4rem 0;
    flex: 1 1;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.8rem;
    text-transform: lowercase;
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
    border: 1px solid transparent;
    border: none;
    opacity: 1;
    color: var(--font-color);
    background: linear-gradient(180deg, var(--bg-color-start) 0%, var(--bg-color-end) 100%);
    border-color: var(--border-color);
    transition: opacity .2s ease-out 0s, --bg-color-start .2s ease-out 0s, --bg-color-end .2s ease-out 0s, --border-color .2s ease-out 0s;
}
.select-color__color.small{
    height: 0.5rem;
    width: 50px;
    padding: 1rem 0;
}
.select-color__color:hover {
    /*border: 2px solid transparent;*/
    transition-duration: 0.2s;
    transition-property: box-shadow;
    box-shadow: var(--font-color) 0px 3px 5px 1px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Roulete_snakes/index_global.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;AACA;;IAEI,aAAa;;AAEjB;AACA;IACI,aAAa;;AAEjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,UAAU;IAGV,mCAAmC;IACnC,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,6BAAoB;IAApB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,mCAAmC;IACnC,kCAAkC;AACtC;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,oBAAoB;;AAExB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,eAAe;IACf,eAAe;IACf,YAAY;IACZ,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,iCAAiC;IACjC,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IAGf,kQAAkQ;AACtQ;;AAEA,6DAA6D;AAC7D,yCAAyC;AACzC;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;IACjC,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,cAAc;IACd,iBAAiB;;AAErB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;IACV,6BAA0B;IAA1B,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,6BAA6B;IAC7B,YAAY;IACZ,sBAAsB;IAGtB,kCAAkC;AACtC;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;;;AAIA,QAAQ;AACR,0BAA0B;AAC1B,mCAAmC;AACnC,2BAA2B;AAC3B,0BAA0B;AAC1B,4BAA4B;AAC5B,+BAA+B;AAC/B,2BAA2B;AAC3B,sBAAsB;AACtB,kBAAkB;AAClB,mBAAmB;AACnB,uBAAuB;AACvB,sBAAsB;AACtB,oCAAoC;AACpC,4BAA4B;AAC5B,uBAAuB;AACvB,2BAA2B;AAC3B,yCAAyC;AACzC,2BAA2B;AAC3B,wBAAwB;AACxB,yBAAyB;AACzB,sBAAsB;AACtB,iCAAiC;AACjC,kBAAkB;AAClB,4BAA4B;AAC5B,2BAA2B;AAC3B,wBAAwB;AACxB,iCAAiC;AACjC,yBAAyB;AACzB,uBAAuB;AACvB,2QAA2Q;AAC3Q,wQAAwQ;AACxQ,mQAAmQ;;AAEnQ,IAAI;;AAEJ;IACI,gBAAgB;IAChB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,SAAO;;IAEP,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,WAAW;IACX,6FAA6F;IAC7F,iCAAiC;IAGjC,qIAAqI;AACzI;AACA;;AAEA;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI;QACI,YAAY;;;IAGhB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;;;;AAKJ;AACA;IACI;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI;;QAEI,YAAY;;;IAGhB;IACA;;QAEI,UAAU;;IAEd;AACJ;;AAEA;;IAEI,sBAAsB,EAAE,iCAAiC;IACzD,sBAAsB,EAAE,6CAA6C;IACrE,+BAA+B,EAAE,oDAAoD;IACrF,4BAA4B,EAAE,iDAAiD;IAC/E,0CAA0C;IAC1C,WAAW;IACX,yBAAyB;;IAEzB,aAAa;IACb,QAAQ;;AAEZ;;;;AAIA;IACI;;QAEI,gBAAgB;QAChB,WAAW;;;IAGf;;IAEA;QACI,iBAAiB;QACjB,cAAc;;IAElB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,wBAAwB,EAAE,8BAA8B;;;IAG5D;;IAEA;QACI,gBAAgB;QAChB,WAAW;;IAEf;;AAEJ;;AAEA;;;;;IAKI,qBAAqB;;;AAGzB;;AAEA;IACI,qBAAqB;IACrB,yCAAyC;IACzC,uCAAuC;IACvC,wCAAwC;AAC5C;;;;;AAKA;IACI,qBAAqB;IACrB,yCAAyC;IACzC,uCAAuC;IACvC,wCAAwC;;AAE5C;AACA;IACI,qBAAqB;IACrB,yCAAyC;IACzC,uCAAuC;IACvC,wCAAwC;;AAE5C;AACA;IACI,qBAAqB;IACrB,sCAAsC;IACtC,oCAAoC;IACpC,wCAAwC;AAC5C;AACA;IACI,qBAAqB;IACrB,0CAA0C;IAC1C,uCAAuC;IACvC,wCAAwC;AAC5C;AACA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,iCAAiC;IACjC,kCAAkC;;AAEtC;AACA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,iCAAiC;IACjC,kCAAkC;;AAEtC;AACA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;IACpC,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,SAAO;IACP,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,UAAU;IACV,wBAAwB;IACxB,uFAAuF;IACvF,iCAAiC;IAGjC,qIAAqI;AACzI;AACA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;AACA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,+BAA+B;IAC/B,6CAA6C;AACjD","sourcesContent":["body {\n    background-color: #11172E !important;\n}\n.fill-yellow-hover {\n\n    fill: #f24e4e;\n\n}\n.fill-gray {\n    fill: #1b6af6;\n\n}\n.fill-red {\n    fill: #fdc340;\n}\n.fill-green {\n    fill: #0eec07;\n}\n.select-color__colors {\n    display: flex;\n    gap: .4rem;\n    margin-top: 1rem;\n    height: 4.6rem;\n}\n.select-color__color[_ngcontent-ng-c3991595663] .icon[_ngcontent-ng-c3991595663] {\n    font-size: 1.6rem;\n    opacity: 0;\n    -webkit-transition: opacity .2s ease-out 0s;\n    -moz-transition: opacity .2s ease-out 0s;\n    transition: opacity .2s ease-out 0s;\n    display: none;\n}\n.icon {\n    position: relative;\n    color: inherit;\n    font-family: icomoon !important;\n    font-style: normal;\n    font-weight: 400;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\ncanvas{\n    animation: AppearCanvas 1s ease-in-out;\n}\n.count_players{\n    position: absolute;\n    right: 10px;\n    top:10px;\n    background-color: rgba(17,23,32,.75);\n    padding: 10px;\n    border-radius: 10px;\n    z-index: 3;\n}\n.canvas{\n    transition: width 2s;\n\n}\n.gameCont{\n    transition: opacity 1s;\n}\n.btnBet {\n    --bgc: transparent;\n    --border-color: transparent;\n    --icon-size: 2.2rem;\n    position: relative;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    flex: 0 0 auto;\n    gap: .6rem;\n    /*width: auto;*/\n    min-width: auto;\n    height: 3rem;\n    background-color: var(--bgc);\n    padding-inline: 1rem;\n    border-width: 0;\n    border-style: solid;\n    border-color: var(--border-color);\n    border-radius: 1rem;\n    font-weight: 700;\n    font-size: 1.6rem;\n    line-height: 1;\n    opacity: 1;\n    text-transform: none;\n    white-space: nowrap;\n    overflow: hidden;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: pointer;\n    -webkit-transition: --main-btn-gradient-start .2s ease-out 0s, --main-btn-gradient-end .2s ease-out 0s, background-color .2s ease-out 0s, border-color .2s ease-out 0s, color .2s ease-out 0s, filter .2s ease-out 0s, opacity .2s ease-out 0s, visibility .2s ease-out 0s;\n    -moz-transition: --main-btn-gradient-start .2s ease-out 0s, --main-btn-gradient-end .2s ease-out 0s, background-color .2s ease-out 0s, border-color .2s ease-out 0s, color .2s ease-out 0s, filter .2s ease-out 0s, opacity .2s ease-out 0s, visibility .2s ease-out 0s;\n    transition: --main-btn-gradient-start .2s ease-out 0s, --main-btn-gradient-end .2s ease-out 0s, background-color .2s ease-out 0s, border-color .2s ease-out 0s, color .2s ease-out 0s, filter .2s ease-out 0s, opacity .2s ease-out 0s, visibility .2s ease-out 0s;\n}\n\n/*body>canvas { width:100%!important; height:100%!important;*/\n/*    position:fixed; top:0; left:60px }*/\n.canvas {\n    position: relative;\n}\n\n.bet-form {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-width: 330px;\n}\n\n.bet-form__label {\n    color: whitesmoke;\n    font-family: \"Gilroy\", sans-serif;\n    font-weight: 500;\n    font-size: 1.2rem;\n    line-height: 1.6rem;\n    text-align: center;\n    letter-spacing: 1px;\n}\n\n.bet-form__wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: .4rem;\n    width: 100%;\n    height: 3.5rem;\n    margin-top: 1rem;\n    border: 1px solid transparent;\n    border-color: #3b477a;\n    border-radius: .8rem;\n}\n\n.manual-bet__actions {\n    display: flex;\n    gap: .4rem;\n    height: 2.8rem;\n    margin-top: .5rem;\n    \n}\n\n.manual-bet__action.is-active {\n    background-color: #6288d4;\n    color: #f4f7ff;\n}\n\n\n.manual-bet__action {\n    background-color: #333f70;\n    color: #a5b6e0;\n    flex: 1 1 100%;\n    height: 100%;\n    padding: 7px;\n    border: none;\n    border-radius: .8rem;\n    font-size: 0.9rem;\n    font-weight: 700;\n    line-height: 1.5rem;\n}\n\n.currency_CSF, .currency_USD {\n    display: inline-flex;\n    align-items: center;\n    gap: .2rem;\n    font-variant: tabular-nums;\n    letter-spacing: 1px;\n}\n\n.bet-form__wrapper .bet-form__currency {\n    display: block;\n    margin-left: 1.4rem;\n    font-weight: 500;\n    font-size: 1.5rem;\n    color: #b3c3ec;\n}\n\n.bet-form__input, .bet-form__input::placeholder {\n    color: #e0e6ff;\n    font-size: 1.2rem;\n    font-weight: 500;\n    line-height: 1.8rem;\n}\n\n.bet-form__input {\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    background-color: transparent;\n    border: none;\n    border-radius: inherit;\n    -webkit-transition: filter .2s ease-out 0s;\n    -moz-transition: filter .2s ease-out 0s;\n    transition: filter .2s ease-out 0s;\n}\n.manual-bet__form .fa-trash{\n    font-size: 1.5rem;\n    margin-right: 10px;\n    color: #58638980;\n    cursor: pointer;\n}\n\n\n\n/*.btn{*/\n/*    --bgc: transparent;*/\n/*    --border-color: transparent;*/\n/*    --icon-size: 2.2rem;*/\n/*    position: relative;*/\n/*    display: inline-flex;*/\n/*    justify-content: center;*/\n/*    align-items: center;*/\n/*    flex: 0 0 auto;*/\n/*    gap: .6rem;*/\n/*    width: auto;*/\n/*    min-width: auto;*/\n/*    height: 6.4rem;*/\n/*    background-color: var(--bgc);*/\n/*    padding-inline: 1rem;*/\n/*    border-width: 0;*/\n/*    border-style: solid;*/\n/*    border-color: var(--border-color);*/\n/*    border-radius: 1rem;*/\n/*    font-weight: 700;*/\n/*    font-size: 1.6rem;*/\n/*    line-height: 1;*/\n/*    color: var(--color, #fff);*/\n/*    opacity: 1;*/\n/*    text-transform: none;*/\n/*    white-space: nowrap;*/\n/*    overflow: hidden;*/\n/*    -webkit-user-select: none;*/\n/*    user-select: none;*/\n/*    cursor: pointer;*/\n/*    -webkit-transition: --main-btn-gradient-start .2s ease-out 0s,--main-btn-gradient-end .2s ease-out 0s,background-color .2s ease-out 0s,border-color .2s ease-out 0s,color .2s ease-out 0s,filter .2s ease-out 0s,opacity .2s ease-out 0s,visibility .2s ease-out 0s;*/\n/*    -moz-transition: --main-btn-gradient-start .2s ease-out 0s,--main-btn-gradient-end .2s ease-out 0s,background-color .2s ease-out 0s,border-color .2s ease-out 0s,color .2s ease-out 0s,filter .2s ease-out 0s,opacity .2s ease-out 0s,visibility .2s ease-out 0s;*/\n/*    transition: --main-btn-gradient-start .2s ease-out 0s,--main-btn-gradient-end .2s ease-out 0s,background-color .2s ease-out 0s,border-color .2s ease-out 0s,color .2s ease-out 0s,filter .2s ease-out 0s,opacity .2s ease-out 0s,visibility .2s ease-out 0s;*/\n\n/*}*/\n\n.bet-creator__action {\n    margin-top: 1rem;\n    width: 100%;\n    border-radius: .8rem;\n}\n\n.btn_blue {\n    background-color: #5d7ef2;\n    color: #fff;\n\n}\n\n.select-color__color {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: .4rem;\n    /*height: 100%;*/\n    border-radius: 1rem;\n    padding: 1rem 0;\n    flex: 1;\n\n    /*font-size: 1.5rem;*/\n    line-height: 1.8rem;\n    text-transform: uppercase;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: pointer;\n    border: 1px solid transparent;\n    opacity: .5;\n    background: linear-gradient(180deg, rgba(90, 96, 228, .224) 0%, rgba(88, 103, 236, .64) 100%);\n    border-color: var(--border-color);\n    -webkit-transition: opacity .2s ease-out 0s, --bg-color-start .2s ease-out 0s, --bg-color-end .2s ease-out 0s, --border-color .2s ease-out 0s;\n    -moz-transition: opacity .2s ease-out 0s, --bg-color-start .2s ease-out 0s, --bg-color-end .2s ease-out 0s, --border-color .2s ease-out 0s;\n    transition: opacity .2s ease-out 0s, --bg-color-start .2s ease-out 0s, --bg-color-end .2s ease-out 0s, --border-color .2s ease-out 0s;\n}\n.select-color__color.small{\n\n}\n\n.selected {\n    opacity: 1;\n}\n\n@media (max-width: 1000px) {\n    \n    .btn_blue {\n        height: 4rem;\n\n\n    }\n\n    .btnBet {\n        height: 3rem;\n    }\n\n    .bet-creator__action {\n        margin-top: 0;\n    }\n\n    .bet-form__wrapper {\n        margin-top: 10px;\n        height: 3.5rem;\n    }\n\n    \n\n\n}\n@keyframes AppearCanvas {\n    0%{\n        opacity: 0.1;\n    }\n    100%{\n        opacity: 1;\n    }\n}\n@keyframes Appear {\n    0% {\n\n        opacity: 0.1;\n\n\n    }\n    100% {\n\n        opacity: 1;\n\n    }\n}\n\n.gameCont {\n   \n    animation-name: Appear; /* Указываем имя вашей анимации */\n    animation-duration: 2s; /* Устанавливаем продолжительность анимации */\n    animation-timing-function: ease; /* Устанавливаем функцию времени (timing function) */\n    animation-iteration-count: 1; /* Устанавливаем количество повторений анимации */\n    transition: width 2s, height 4s,opacity 1s;\n    width: 100%;\n    cursor: default!important;\n\n    display: flex;\n    order: 2;\n\n}\n\n\n\n@keyframes side_center_gameCont {\n    0% {\n\n        max-width: 800px;\n        margin: 0 0;\n\n\n    }\n\n    100% {\n        max-width: 1200px;\n        margin: 0 auto;\n\n    }\n}\n\n@keyframes side_left_gameCont {\n    0% {\n        max-width: 1200px;\n        transform: translateX(0); /* Начальное положение блока */\n\n\n    }\n\n    100% {\n        max-width: 800px;\n        margin: 0 0;\n\n    }\n\n}\n\n.gameCont.close {\n    \n    \n\n\n    opacity: 1 !important;\n\n\n}\n\n.select-color__color.is-active.select-color__color_x2 {\n    --font-color: #94B2FF;\n    --bg-color-start: rgba(90, 96, 228, .224);\n    --bg-color-end: rgba(88, 103, 236, .64);\n    --border-color: rgba(139, 157, 254, .18);\n}\n\n\n\n\n.select-color__color_x2 {\n    --font-color: #94B2FF;\n    --bg-color-start: rgba(90, 96, 228, .224);\n    --bg-color-end: rgba(88, 103, 236, .64);\n    --border-color: rgba(139, 157, 254, .18);\n\n}\n.select-color__color_x50 {\n    --font-color: #A4FDC7;\n    --bg-color-start: rgba(43, 172, 71, .224);\n    --bg-color-end: rgba(74, 202, 110, .64);\n    --border-color: rgba(139, 254, 185, .18);\n\n}\n.select-color__color_x3 {\n    --font-color: #ef294e;\n    --bg-color-start: rgb(208 74 74 / 12%);\n    --bg-color-end: rgb(255 11 11 / 34%);\n    --border-color: rgba(184, 151, 255, .18);\n}\n.select-color__color_x5 {\n    --font-color: #FFEDC8;\n    --bg-color-start: rgba(216, 164, 87, .224);\n    --bg-color-end: rgba(218, 197, 87, .64);\n    --border-color: rgba(254, 208, 139, .18);\n}\n.select-color__color_x2_block {\n    --font-color: #94B2FF;\n    --bg-color-start: rgb(90, 96, 228);\n    --bg-color-end: rgb(88, 103, 236);\n    --border-color: rgb(139, 157, 254);\n\n}\n.select-color__color_x50_block {\n    --font-color: #A4FDC7;\n    --bg-color-start: rgb(43, 172, 71);\n    --bg-color-end: rgb(74, 202, 110);\n    --border-color: rgb(139, 254, 185);\n\n}\n.select-color__color_x3_block {\n    --font-color: #ef294e;\n    --bg-color-start: rgb(208 74 74);\n    --bg-color-end: rgb(255 11 11);\n    --border-color: rgb(184, 151, 255);\n}\n\n.select-color__color_x5_block {\n    --font-color: #FFEDC8;\n    --bg-color-start: rgba(216, 164, 87);\n    --bg-color-end: rgba(218, 197, 87);\n    --border-color: rgba(254, 208, 139);\n}\n\n.select-color__color {\n    display: flex;\n    align-items: center;\n    letter-spacing: 1px;\n    justify-content: center;\n    gap: .4rem;\n    height: 2rem;\n    width: 5.3rem;\n    border-radius: 0.7rem;\n    padding: 1.4rem 0;\n    flex: 1;\n    font-weight: 700;\n    font-size: 1.5rem;\n    line-height: 1.8rem;\n    text-transform: lowercase;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: pointer;\n    border: 1px solid transparent;\n    border: none;\n    opacity: 1;\n    color: var(--font-color);\n    background: linear-gradient(180deg, var(--bg-color-start) 0%, var(--bg-color-end) 100%);\n    border-color: var(--border-color);\n    -webkit-transition: opacity .2s ease-out 0s, --bg-color-start .2s ease-out 0s, --bg-color-end .2s ease-out 0s, --border-color .2s ease-out 0s;\n    -moz-transition: opacity .2s ease-out 0s, --bg-color-start .2s ease-out 0s, --bg-color-end .2s ease-out 0s, --border-color .2s ease-out 0s;\n    transition: opacity .2s ease-out 0s, --bg-color-start .2s ease-out 0s, --bg-color-end .2s ease-out 0s, --border-color .2s ease-out 0s;\n}\n.select-color__color.small{\n    height: 0.5rem;\n    width: 50px;\n    padding: 1rem 0;\n}\n.select-color__color:hover {\n    /*border: 2px solid transparent;*/\n    transition-duration: 0.2s;\n    transition-property: box-shadow;\n    box-shadow: var(--font-color) 0px 3px 5px 1px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
